module.exports = __webpack_public_path__ + "img/big-number-execution.4ab9dc42.svg";